exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "async-event-component .fn-asyncItem {\n  opacity: 0; }\n\nasync-event-component .c-list1__card {\n  display: block; }\n", ""]);

// exports
